function initUrlSetter() {
  var dynamicUrls = document.getElementsByClassName('dynamic-url');
  var i;
  var url;
  for (i = 0; i < dynamicUrls.length; i++) {
    url = dynamicUrls[i].dataset.href;
    dynamicUrls[i].href = url;
  }
}

module.exports = {
  init: initUrlSetter,
};
